import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 15px;
  overflow: hidden;
`;

export const SkeletonItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 350px;
  min-height: 130px;
  border-radius: 10px;
  padding: 15px;
  background-color: ${({ theme }) => theme.neutral_100};
  opacity: 1;
  animation: fadeIn 1s 1;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Line_code = css`
  width: 140px;
  height: 16px;
`;

const Line_name = css`
  width: 120px;
`;

const Line_date = css`
  width: 170px;
`;

const Line_status = css`
  width: 120px;
  height: 22px;
  border-radius: 50px;
`;

const Line_salesModeIcon = css`
  width: 110px;
  height: 15px;
`;

const Line_salesMode = css`
  width: 70px;
`;

const variants = {
  code: Line_code,
  name: Line_name,
  date: Line_date,
  status: Line_status,
  'sales-mode-icon': Line_salesModeIcon,
  'sales-mode': Line_salesMode,
};

export const Line = styled.div<{
  $variant:
    | 'code'
    | 'name'
    | 'date'
    | 'status'
    | 'sales-mode-icon'
    | 'sales-mode';
}>`
  height: 14px;
  width: 100px;
  border-radius: 4px;
  background: linear-gradient(
    to right,
    rgba(130, 130, 130, 0.3) 20%,
    rgba(130, 130, 130, 0) 30%,
    rgba(130, 130, 130, 0.3) 50%
  );
  background-size: 800px 100px;
  animation: wave-lines 2s infinite ease-in-out;

  @keyframes wave-lines {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -150% 0;
    }
  }

  ${({ $variant }) => variants[$variant]}
`;

export const Section = styled.div<{ $alignEnd?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  gap: 5px;
  color: ${({ theme }) => theme.neutral_500};

  ${({ $alignEnd }) => $alignEnd && 'align-items: flex-end;'}
`;

export const Container = styled.div<{ $alignEnd?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  ${({ $alignEnd }) => $alignEnd && 'align-items: flex-end;'}
`;

export const Division = styled.hr`
  background-color: ${({ theme }) => theme.neutral_700};
  opacity: 0.1;
  width: 100%;
  height: 1px;
`;
